import { render, staticRenderFns } from "./dialogDiscovery.vue?vue&type=template&id=0e50ff90&"
import script from "./dialogDiscovery.vue?vue&type=script&lang=js&"
export * from "./dialogDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports